<template>
    <article>
        <p>
            Coroot automatically discovers and monitors every application rollout in your Kubernetes cluster.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspections/deployments.png" />
        </v-card>


        <p>
            This inspection uses metrics gathered by <var>kube-state-metrics</var> to detect that an application (Kubernetes Deployment) has been updated.
            Using Kubernetes metadata to detect rollouts has two main advantages.
            Firstly, this is the most up-to-date information about the state of applications.
            Secondly, this approach eliminates the need to integrate Coroot with CI/CD tools.
        </p>

        <v-img eager max-width="800" class="ma-auto my-6" src="/static/img/docs/coroot-ce/inspections/deployments-rollout-detection.png" />

        <p>
            Upon identifying a new rollout, Coroot immediately starts monitoring its status.
            The possible states of a rollout are as follows:
        </p>

        <v-img eager max-width="800" class="ma-auto my-6" src="/static/img/docs/coroot-ce/inspections/deployments-rollout-statuses.svg" />

        <p>
            A rollout is considered "Stuck" if it lasts for more than 3 minutes (the threshold can be easily adjusted for any application or an entire project).
            This can occur due to issues related to container images or if a new pod cannot be scheduled on a cluster node.
        </p>


        <p>
            Coroot audits each application 30 minutes after its new version is deployed to evaluate its performance in comparison to the previous version, using the following criteria:
        </p>

        <ul>
            <li>SLOs (Availability & Latency)</li>
            <li>The number of errors in the application logs</li>
            <li>Container restarts</li>
            <li>CPU consumption</li>
            <li>Memory leaks</li>
        </ul>

        <p>
            Notifications of all notable changes are sent to your Slack workspace to ensure that you don't miss even the slightest performance degradation.
        </p>

        <v-img eager max-width="1000" class="ma-auto my-6" src="/static/img/docs/coroot-ce/inspections/deployments-slack.png" />

        <p>
            You can turn off such notifications for any particular <router-link :to="{name: 'docs', params: {chapter: 'coroot', group: 'configuration', item: 'application-categories'}}">application category</router-link>:
        </p>

        <v-card max-width="600">
            <v-img eager src="/static/img/docs/coroot-ce/inspections/deployments-disable-notification.png" />
        </v-card>

    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
